<!-- Communication Center - Epic 4 Story 4.1: redesigned Prospect/Customer Call Log -->
<!-- Outside the modal so it also covers the page while the first load runs, before the modal is shown. -->
<app-loader *ngIf="loading"></app-loader>

<div class="modal fade" bsModal #ProspectCustomerCallLog="bs-modal" tabindex="-1" role="dialog" (onHide)="onCallLogHide()" (onShown)="onCallLogShown()">
  <div class="modal-dialog modal-dialog-centered modal_80" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <ng-container *ngIf="result?.TenantName; else defaultTitle">{{ result.TenantName }}</ng-container>
          <ng-template #defaultTitle>Call Log</ng-template>
        </h5>
        <button type="button" class="close" data-commits-row (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0 prospect-call-log">

        <!-- FR-15: summary tiles -->
        <div class="score-tiles" *ngIf="result">
          <div class="score-tile">
            <div class="score-label">AVG AI Score</div>
            <div class="score-value" [ngClass]="result.Summary.AverageAiScore != null ? scoreClass(result.Summary.AverageAiScore) : ''">
              {{ result.Summary.AverageAiScore != null ? (result.Summary.AverageAiScore | number:'1.0-0') : '-' }}
            </div>
          </div>
          <div class="score-tile">
            <div class="score-label">Total Calls</div>
            <div class="score-value">{{ result.Summary.TotalCalls }}</div>
          </div>
          <div class="score-tile">
            <div class="score-label">Voicemails</div>
            <div class="score-value">{{ result.Summary.Voicemails }}</div>
          </div>        </div>

        <div class="call-log-toolbar d-flex flex-wrap align-items-center">
          <div class="call-type-toggle" role="group" data-commits-row>
            <button type="button" [class.active]="callType === 'All'" (click)="setCallType('All')">All</button>
            <button type="button" [class.active]="callType === 'Calls'" (click)="setCallType('Calls')">Calls</button>
            <button type="button" [class.active]="callType === 'Voicemails'" (click)="setCallType('Voicemails')">Voicemails</button>
          </div>
        </div>

        <div class="table-responsive call-log-table-wrap" *ngIf="result">
          <table class="table mb-0 prospect-call-log-table">
            <thead>
              <tr>
                <th class="date-col" [attr.aria-sort]="sortDescending ? 'descending' : 'ascending'">
                  <button type="button" class="sort-header" (click)="toggleDateSort()">
                    Date &amp; Time <i class="fa" [ngClass]="sortDescending ? 'fa-caret-down' : 'fa-caret-up'" aria-hidden="true"></i>
                  </button>
                </th>
                <th class="direction-col">Direction</th>
                <th>Duration</th>
                <th class="sentiment-col">Sentiment</th>
                <th>Category / Reason</th>
                <th>Tags</th>
                <th>Employee / Agent</th>
                <th>AI Score</th>
                <th class="human-score-col">Human Score</th>
                <th class="text-center">Audio</th>
                <th></th>
                <th>Store Name</th>
                <th>Ad Source</th>
                <th>Caller ID</th>
                <th>Tracking #</th>
              </tr>
              <tr class="filter-row">
                <th><input type="text" class="filter-input-md" [(ngModel)]="columnFilters.date" (ngModelChange)="applyFilters()" aria-label="Filter date"></th>
                <th><input type="text" class="filter-input-sm" [(ngModel)]="columnFilters.direction" (ngModelChange)="applyFilters()" aria-label="Filter direction"></th>
                <th><input type="text" class="filter-input-xs" [(ngModel)]="columnFilters.duration" (ngModelChange)="applyFilters()" aria-label="Filter duration"></th>
                <th><input type="text" class="filter-input-sm" [(ngModel)]="columnFilters.sentiment" (ngModelChange)="applyFilters()" aria-label="Filter sentiment"></th>
                <th><input type="text" class="filter-input-md" [(ngModel)]="columnFilters.category" (ngModelChange)="applyFilters()" aria-label="Filter category"></th>
                <th><input type="text" class="filter-input-sm" [(ngModel)]="columnFilters.tags" (ngModelChange)="applyFilters()" aria-label="Filter tags"></th>
                <th><input type="text" class="filter-input-sm" [(ngModel)]="columnFilters.agent" (ngModelChange)="applyFilters()" aria-label="Filter employee"></th>
                <th><input type="text" class="filter-input-xs" [(ngModel)]="columnFilters.aiScore" (ngModelChange)="applyFilters()" aria-label="Filter AI score"></th>
                <th><input type="text" class="filter-input-xs" [(ngModel)]="columnFilters.humanScore" (ngModelChange)="applyFilters()" aria-label="Filter human score"></th>
                <th></th>
                <th></th>
                <th><input type="text" class="filter-input-md" [(ngModel)]="columnFilters.storeName" (ngModelChange)="applyFilters()" aria-label="Filter store name"></th>
                <th><input type="text" class="filter-input-md" [(ngModel)]="columnFilters.adSource" (ngModelChange)="applyFilters()" aria-label="Filter ad source"></th>
                <th><input type="text" class="filter-input-md" [(ngModel)]="columnFilters.callerId" (ngModelChange)="applyFilters()" aria-label="Filter caller ID"></th>
                <th><input type="text" class="filter-input-md" [(ngModel)]="columnFilters.trackingNumber" (ngModelChange)="applyFilters()" aria-label="Filter tracking number"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of rows; trackBy: trackByPhoneId" [attr.data-phone-id]="item.PhoneId" [class.row-editing]="isActiveRow(item)">
                <td class="text-nowrap text-center">{{ formatDateTime(item.CallDateTime) }}</td>
                <td class="text-nowrap text-center direction-cell"><span class="direction-arrow" aria-hidden="true">{{ directionArrow(item.Direction) }}</span>{{ item.Direction }}</td>
                <td class="text-nowrap text-center">
                  <span *ngIf="durationStatus(item) as status; else durationValue" class="duration-status">{{ status }}</span>
                  <ng-template #durationValue>{{ formatDuration(item.Duration) }}</ng-template>
                </td>
                <td class="text-center">
                  <span *ngIf="item.AiSentiment" class="sentiment-pill" [ngClass]="sentimentClass(item.AiSentiment)">
                    <span class="dot"></span>{{ item.AiSentiment }}
                  </span>
                  <span *ngIf="!item.AiSentiment" class="text-muted">&mdash;</span>
                </td>
                <td>
                  <div class="chip-list">
                    <span class="value-chip" *ngFor="let category of item.CallCategories">
                      {{ category.Name }}
                      <button type="button" class="chip-remove" [class.is-disabled]="!editRight"
                        [attr.title]="editRight ? null : 'You do not have Edit Right'" [attr.aria-disabled]="!editRight"
                        (click)="removeCategory(item, category.Id)" aria-label="Remove category">&times;</button>
                    </span>
                    <select #rowPicker *ngIf="isActiveRow(item) && openPicker === 'category'" class="inline-select" [ngModel]="null"
                      (ngModelChange)="pickCategory(item, $event)" (blur)="closePicker()" aria-label="Add category">
                      <option [ngValue]="null">Add...</option>
                      <option *ngFor="let c of availableCategories(item)" [ngValue]="c.Id">{{ c.Name }}</option>
                    </select>
                    <button type="button" class="add-pill" *ngIf="!(isActiveRow(item) && openPicker === 'category')"
                      [class.is-disabled]="!editRight" [attr.title]="editRight ? null : 'You do not have Edit Right'"
                      [attr.aria-disabled]="!editRight" (click)="openCategoryPicker(item)">+ Add</button>
                  </div>
                </td>
                <td>
                  <div class="chip-list">
                    <span class="value-chip" *ngFor="let tag of item.CallTags">
                      {{ tag.Name }}
                      <button type="button" class="chip-remove" [class.is-disabled]="!editRight"
                        [attr.title]="editRight ? null : 'You do not have Edit Right'" [attr.aria-disabled]="!editRight"
                        (click)="removeTag(item, tag.Id)" aria-label="Remove tag">&times;</button>
                    </span>
                    <select #rowPicker *ngIf="isActiveRow(item) && openPicker === 'tag'" class="inline-select" [ngModel]="null"
                      (ngModelChange)="pickTag(item, $event)" (blur)="closePicker()" aria-label="Add tag">
                      <option [ngValue]="null">Add...</option>
                      <option *ngFor="let t of availableTags(item)" [ngValue]="t.Id">{{ t.Name }}</option>
                    </select>
                    <button type="button" class="add-pill" *ngIf="!(isActiveRow(item) && openPicker === 'tag')"
                      [class.is-disabled]="!editRight" [attr.title]="editRight ? null : 'You do not have Edit Right'"
                      [attr.aria-disabled]="!editRight" (click)="openTagPicker(item)">+ Add</button>
                  </div>
                </td>
                <td class="text-center">
                  <span *ngIf="item.EmployeeName">{{ item.EmployeeName }}</span>
                  <span *ngIf="!item.EmployeeName" class="text-muted">&mdash;</span>
                </td>
                <td class="text-center">
                  <span *ngIf="item.AiScore != null" class="score-text" [ngClass]="scoreClass(item.AiScore)">{{ item.AiScore }}</span>
                  <span *ngIf="item.AiScore == null" class="text-muted">&mdash;</span>
                </td>
                <td class="text-center">
                  <ng-container *ngIf="isActiveRow(item) && scoreEditing; else scoreDisplay">
                    <input #scoreInput type="number" class="inline-score" min="0" max="100" step="1" placeholder="0-100"
                      title="Score Range is 0-100" [(ngModel)]="scoreValue" (input)="onScoreInput(scoreInput)" (keydown)="onScoreKeydown($event)" (paste)="blockScorePaste($event)"
                      (drop)="blockScorePaste($event)" aria-label="Human score">
                    <div class="alert alert-danger score-alert" *ngIf="scoreInvalid" role="alert">Score range is 0-100</div>
                  </ng-container>
                  <ng-template #scoreDisplay>
                    <button type="button" *ngIf="item.HumanScore != null" class="score-text score-edit" [ngClass]="scoreClass(item.HumanScore)"
                      [class.is-disabled]="!editRight" [attr.title]="editRight ? 'Edit Human Score' : 'You do not have Edit Right'"
                      [attr.aria-disabled]="!editRight" (click)="openScoreEditor(item)">{{ item.HumanScore }}</button>
                    <button type="button" *ngIf="item.HumanScore == null" class="add-pill"
                      [class.is-disabled]="!editRight" [attr.title]="editRight ? null : 'You do not have Edit Right'"
                      [attr.aria-disabled]="!editRight" (click)="openScoreEditor(item)">+ Add</button>
                  </ng-template>
                </td>
                <td class="text-center">
                  <button type="button" class="audio-btn" data-commits-row *ngIf="hasRecording(item)" (click)="openCallDetail(item)" title="Play / view detail" aria-label="Play / view detail">
                    <i class="fa fa-play"></i>
                  </button>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-primary" data-commits-row [class.is-disabled]="!editRight"
                    [attr.title]="editRight ? null : 'You do not have Edit Right'" [attr.aria-disabled]="!editRight"
                    (click)="onRelinkClick(item)">Relink</button>
                </td>
                <td class="text-center">
                  <span *ngIf="item.FacilityName">{{ item.FacilityName }}</span>
                  <span *ngIf="!item.FacilityName" class="text-muted">&mdash;</span>
                </td>
                <td class="text-center">
                  <span *ngIf="item.AdSourceName">{{ item.AdSourceName }}</span>
                  <span *ngIf="!item.AdSourceName" class="text-muted">&mdash;</span>
                </td>
                <td class="text-nowrap text-center">
                  <span *ngIf="item.PhoneNumber">{{ formatCallerId(item.PhoneNumber) }}</span>
                  <span *ngIf="!item.PhoneNumber" class="text-muted">&mdash;</span>
                </td>
                <td class="text-nowrap text-center">
                  <span *ngIf="item.TrackingNumber">{{ formatCallerId(item.TrackingNumber) }}</span>
                  <span *ngIf="!item.TrackingNumber" class="text-muted">&mdash;</span>
                </td>
              </tr>
              <tr *ngIf="rows.length === 0">
                <td colspan="15" class="text-center text-muted py-3">No calls found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #CallDetailModal="bs-modal" tabindex="-1" role="dialog" (onHidden)="onCallDetailHidden()">
  <div class="modal-dialog modal-dialog-centered modal_80" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <ng-container *ngIf="result?.TenantName; else defaultDetailTitle">
            {{ result.TenantName }}<ng-container *ngIf="selectedCall?.UnitNumber"> &middot; Unit {{ selectedCall.UnitNumber }}</ng-container>
          </ng-container>
          <ng-template #defaultDetailTitle>Call Detail</ng-template>
        </h5>
        <button type="button" class="close" (click)="closeCallDetail()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0">
        <app-prospect-customer-call-detail *ngIf="selectedCall" [item]="selectedCall" [customerName]="result?.TenantName" (loaded)="onCallDetailLoaded()"></app-prospect-customer-call-detail>
      </div>
    </div>
  </div>
</div>
